import { Slider } from "antd";
import { forwardRef } from "react";
import type { ComponentPropsWithoutRef, ComponentRef } from "react";

const DEFAULT_WIDTH_PX = 200;

export type VLSliderRef = ComponentRef<typeof Slider>;

export type VLSliderProps = ComponentPropsWithoutRef<typeof Slider>;

const VLSlider = forwardRef<VLSliderRef, VLSliderProps>((props, ref) => {
  const { min = 0, max = 1, step = 0.01, style, ...rest } = props;

  return (
    <Slider
      ref={ref}
      min={min}
      max={max}
      step={step}
      style={{ width: DEFAULT_WIDTH_PX, ...style }}
      {...rest}
    />
  );
});

export default VLSlider;
